<template>
    <v-card class="send-back-reason-dialog custom-dailog">
        <v-card-title>
            {{chapterWaiverConstants.DENIAL_REASON}}
            <i class="fas fa-times" @click="closeDialog()" data-qe-id="closeDenyDialogBoxIcon"></i>
        </v-card-title>
        <v-card-text>
            <v-layout row wrap>
                <v-flex xs9 class="send-back-reason-dialog__error">
                    <v-flex v-if="showError">{{chapterWaiverConstants.ERROR_OCCURRED}}</v-flex>
                </v-flex>
                <v-flex text-xs-right xs3 data-qe-id="denyTextLength">
                    {{denyReasonText.length}} {{validationText}}
                </v-flex>
            </v-layout>
            <v-textarea
                :disabled="updateInProgress"
                data-qe-id="denyReasonText"
                @paste="isPasted($event)"
                v-model="denyReasonText"
                @keypress="textCountLimiter($event, denyReasonText, waiverFormConstants.MAX_REASON_LENGTH)">
            </v-textarea>
        </v-card-text>
        <v-card-actions>
            <v-flex text-xs-right class="pt-2 pb-2 pl-1 pr-3">
                <v-btn
                    :disabled="updateInProgress"
                    data-qe-id="cancelDenyDialogBoxBtn"
                    class="primary_btn transparent small"
                    @click="closeDialog()">{{actionConstants.CANCEL}}</v-btn>
                <v-btn
                    :loading="updateInProgress"
                    data-qe-id="denyConfirmBtn"
                    class="primary_btn small"
                    @click="confirmAndDeny()">{{actionConstants.CONFIRM_AND_DENY}}</v-btn>
            </v-flex>
        </v-card-actions>
    </v-card>
</template>

<script>
    import { appCommonConstants } from "../appCommon.constants";
    import { chapterWaiverConstants, waiverFormConstants, waiverFormTypesConstants, actionConstants } from "./ChapterWaiver.constants";
    import { mapState, mapGetters, mapActions } from "vuex";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { textCountLimiter } from "../../common/utils/utils";

    export default {
        name: 'DenyVoteDialog',
        created() {
            this.denyReasonText = '';
        },
        data: () => {
            return {
                appCommonConstants,
                waiverFormTypesConstants,
                chapterWaiverConstants,
                waiverFormConstants,
                showWaiver: false,
                actionConstants,
                denyReasonText: '',
                showError: false,
                updateInProgress: false,
                disableCancelBtn: false,
                disabledenyReasonTextField: false,
            };
        },
        props: {
            leadId: {
                type: String,
                required: true,
            },
            closeDialogBox: {
                type: Function,
                required: true,
            },
            sequence: {
                type: Number,
                required: true,
            },
        },
        methods: {
            textCountLimiter,

            isPasted($event) {
                const text = $event.clipboardData.getData("text");
                if ((this.denyReasonText.length + text.length) > this.waiverFormConstants.MAX_REASON_LENGTH) {
                    $event.preventDefault();
                    return true;
                }
            },

            async confirmAndDeny() {
                this.updateInProgress = true;
                const reqComment = {
                    leadId: this.leadId,
                    commentText: this.denyReasonText,
                };
                const reqVote = {
                    id: this.sequence,
                    leadid: this.leadId,
                    votestatus: this.chapterWaiverConstants.DENIED,
                };
                await this.savePRPMemberDenyReason(reqComment);
                this.showError = this.errorOccurred;
                if (this.errorOccurred) {
                    setTimeout(() => {
                        this.showError = false;
                    }, 3000);
                }
                this.resetDenyReasonText();
                await this.submitVote(reqVote);
                this.closeDialog();
                this.updateInProgress = false;
            },

            ...mapActions({
                submitVote: `chapterWaiver/${storeAction.submitVote}`,
                savePRPMemberDenyReason: `chapterWaiver/${storeAction.savePRPMemberDenyReason}`,
            }),
            resetDenyReasonText() {
                this.denyReasonText = '';
            },
            closeDialog() {
                this.resetDenyReasonText();
                this.closeDialogBox();
            },
        },
        computed: {
            ...mapState("actionState", ["actions"]),
            ...mapGetters({
                errorOccurred: `chapterWaiver/${storeGetters.voteStatusError}`,
            }),

            validationText() {
                return `${this.waiverFormConstants.OF} ${this.waiverFormConstants.MAX_REASON_LENGTH} ${this.waiverFormConstants.CHARACTERS}`;
            },

            disableUpdate() {
                const reason = this.denyReasonText.trim();
                return this.denyReasonText.length <= 0 || reason === "";
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_commonClasses.scss";

    .error {
        color: $ypo-deep-red;
    }

    .send-back-reason-dialog {
        &.custom-dailog {

            .v-card {
                &__text {
                    margin: 0px;
                    padding: 16px 16px 16px 16px;
                }
            }

            .v-card__title {
                color: $white;
                background: $ypo-blue;
                font-size: 19px;

                i {
                    color: $white;
                    padding: 2px 2px 0px 25px;
                    cursor: pointer;
                }
            }

        }

        &__error {
            color: $ypo-deep-red;
        }
    }
</style><style lang="scss">
    @import "../../common/styles/_colors.scss";

    .send-back-reason-dialog {

        .v-input__slot:before,
        .v-input__slot:after {
            display: none;
        }

        .v-text-field {
            padding: 0px;
            margin: 0px;
        }

        textarea {
            border: 1px solid $ypo-medium-gray;
            border-radius: 3px;
            color: $ypo-blue !important;
            padding: 10px 10px;
            font-size: 14px;
            transition: 0.3s all ease;

            &:focus {
                border: 1px solid rgba($ypo-cta, 0.7);
            }
        }

        .v-messages {
            display: none;
        }
    }
</style>
